import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { adminCreate, getAdminsList, updateAdmin } from "../../../../src/api/admin";
import toast from "react-hot-toast";

const AdminAddEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [data, setData] = useState({
    username: "",
    email: "",
    mobile: "",
    employeeId: "",
    address: "",
    pincode: "",
    password: "",
    role: "admin",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setData({
      ...data,
      [name]: files ? files[0] : value,
    });
  };
  const validate = () => {
    let newErrors = {};

    if (!data.username) newErrors.username = "Full name is required";
    if (!data.email) newErrors.email = "Email is required";
    if (!data.mobile) newErrors.mobile = "Mobile is required";
    if (!data.employeeId) newErrors.employeeId = "Employee ID is required";
    if (!data.address) newErrors.address = "Address is required";
    if (!data.pincode) newErrors.pincode = "Pincode is required";
    if (!id && !data.password) newErrors.password = "Password is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
  toast.error("Please fill all required fields ⚠️");
  return;
}

    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("username", data.username);
      formData.append("email", data.email);
      formData.append("phone", data.mobile);
      formData.append("employeeId", data.employeeId);
      formData.append("address", data.address);
      formData.append("pincode", data.pincode);
      formData.append("role", data.role);

      if (data.password) {
        formData.append("password", data.password);
      }

      if (data.profileImage) {
        formData.append("profileImage", data.profileImage);
      }

      if (id) {
        await updateAdmin(id, formData);
       toast.success("Admin updated successfully ✅");
      } else {
        await adminCreate(formData);
       toast.success("Admin updated successfully ✅");
      }

      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong ❌");
    } finally {
      setLoading(false);
    }
  };

   const fetchAdmin = useCallback(async () => {
  try {
    const res = await getAdminsList();
    const admin = res.data.find((a) => a._id === id);

    if (admin) {
      setData({
        username: admin.username || "",
        email: admin.email || "",
        mobile: admin.phone || "",
        employeeId: admin.employeeId || "",
        address: admin.address || "",
        pincode: admin.pincode || "",
        password: "",
        profileImage: admin.profileImage || "",
        role: admin.role || "admin", // ✅ small fix
      });
    }
  } catch (error) {
    console.error("Failed to fetch admin", error);
  }
}, [id]);


useEffect(() => {
  if (id) {
    fetchAdmin();
  }
}, [id, fetchAdmin]);



  return (
    <div className="container mt-4">
      <h3 className="f2 my-3">{id ? "Edit Admin" : "Add Admin"}</h3>

      <form onSubmit={handleSubmit}>
        <div className="row">

          <div className="col-lg-6 mb-3">
            <label className="f2">User Name</label>
            <input
              name="username"
              className="form-control"
              value={data.username}
              onChange={handleChange}
            />
            {errors.username && <small className="text-danger">{errors.username}</small>}
          </div>

          <div className="col-lg-6 mb-3">
            <label className="f2">Email</label>
            <input
              name="email"
              type="email"
              className="form-control"
              value={data.email}
              onChange={handleChange}
            />
            {errors.email && <small className="text-danger">{errors.email}</small>}
          </div>

          <div className="col-lg-6 mb-3">
            <label className="f2">Mobile</label>
            <input
              name="mobile"
              className="form-control"
              value={data.mobile}
              onChange={handleChange}
            />
            {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
          </div>

          <div className="col-lg-6 mb-3">
            <label className="f2">Employee ID</label>
            <input
              name="employeeId"
              className="form-control"
              value={data.employeeId}
              onChange={handleChange}
            />
            {errors.employeeId && <small className="text-danger">{errors.employeeId}</small>}
          </div>

          <div className="col-lg-6 mb-3">
            <label className="f2">Address</label>
            <input
              name="address"
              className="form-control"
              value={data.address}
              onChange={handleChange}
            />
            {errors.address && <small className="text-danger">{errors.address}</small>}
          </div>
          <div className="col-lg-6 mb-3">
            <label className="f2">Role </label>
            <select
              name="role"
              className="form-control"
              value={data.role}
              onChange={handleChange}
            >
              <option value="admin">Admin</option>
              <option value="superadmin">Super Admin</option>
            </select>
          </div>

          <div className="col-lg-6 mb-3">
            <label className="f2">Pincode</label>
            <input
              name="pincode"
              className="form-control"
              value={data.pincode}
              onChange={handleChange}
            />
            {errors.pincode && <small className="text-danger">{errors.pincode}</small>}
          </div>

          {!id && (
            <div className="col-lg-6 mb-3">
              <label className="f2">Password</label>
              <input
                name="password"
                type="password"
                className="form-control"
                value={data.password}
                onChange={handleChange}
              />
              {errors.password && <small className="text-danger">{errors.password}</small>}
            </div>
          )}
          <div className="col-lg-6 mb-3">
            <label className="f2">Profile Image</label>
            <input
              type="file"
              name="profileImage"
              className="form-control"
              accept="image/*"
              onChange={handleChange}
            />
          </div>
          {data.profileImage && (
            <div className="mb-2">
              <img
                src={
                  typeof data.profileImage === "string"
                    ? data.profileImage
                    : URL.createObjectURL(data.profileImage)
                }
                alt="Preview"
                width="120"
                className="rounded-circle"
              />
            </div>
          )}

        </div>
<div className="d-flex align-item-center justify-content-end">
        <button type="submit" className="add-btn" disabled={loading}>
          {loading ? "Processing..." : id ? "Update Admin" : "Add Admin"}
        </button>
        </div>
      </form>
    </div>
  );
};

export default AdminAddEdit;
